export enum CirraServiceType {
  MAIN = 'main-future', // For future use
  MCP = 'mcp',
  AGENTS = 'main', // For compliance with current back-end. Should change to 'agents' in future
}

export enum AuthMessageType {
  SUCCESS = 'oauth-success',
  ERROR = 'oauth-error',
}
